export const SizeProps = ['xs', 'sm', 'md', 'lg', 'xl',]
  .flatMap(size => Array(12).fill(1).map((x, i) => size + (i + 1)));
